import keyBy from 'lodash/keyBy';
import isEmpty from 'lodash/isEmpty';
import { fetchSegmentFlags } from './feature-flags.utils';

const featureFlags = {
    namespaced: true,
    state: {
        map: {},
    },
    mutations: {
        setMap (state, flags) {
            state.map = keyBy(flags, 'flagName');
        },
    },
    actions: {
        async loadAll ({ commit, state }, { reFetch = false } = {}) {
            if (!isEmpty(state.map) && !reFetch) {
                return;
            }

            const flags = await fetchSegmentFlags();
            commit('setMap', flags);
        },
    },
    getters: {
        list: (state) => Object.values(state.map),
    },
};

export default featureFlags;